import { Box, Button } from "@mui/material";
import { Phone } from "lucide-react";
import { AccountType } from "./SubtaskDetail";
import { isPhoneCallLightningTask } from "types/delegation";
import { formatDelegationPhoneForDisplay } from "./phoneCallTaskUtils";

interface PhoneCallTaskActionsProps {
  accountType: AccountType;
  serviceType: string;
  status: string;
  isMobile: boolean;
  updating: boolean;
  detectedPhone: string | null;
  onDirectCall: (phone: string) => void;
  onMakeCall: () => void;
}

export default function PhoneCallTaskActions({
  accountType,
  serviceType,
  status,
  isMobile,
  updating,
  detectedPhone,
  onDirectCall,
  onMakeCall,
}: PhoneCallTaskActionsProps) {
  if (
    accountType !== "advisor" ||
    !isPhoneCallLightningTask(serviceType) ||
    status === "completed"
  ) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "16px",
        flexDirection: isMobile ? "column" : "row",
      }}
    >
      {detectedPhone ? (
        <>
          <Button
            fullWidth={isMobile}
            size="small"
            onClick={() => onDirectCall(detectedPhone)}
            disabled={updating}
            startIcon={<Phone size={16} />}
          >
            Call {formatDelegationPhoneForDisplay(detectedPhone)}
          </Button>
          <Button
            fullWidth={isMobile}
            variant="outlined"
            size="small"
            onClick={onMakeCall}
            disabled={updating}
          >
            Call a different number
          </Button>
        </>
      ) : (
        <Button
          size="small"
          onClick={onMakeCall}
          disabled={updating}
          startIcon={<Phone size={16} />}
        >
          Start Phone Call
        </Button>
      )}
    </Box>
  );
}
